import { queryDataset, deleteDataset, queryAllDatasets } from "../../utils/fine-tuning-functions";
import { useNavigate } from 'react-router-dom';

export default function SelectDatasets({ datasets, setDatasets }) {
  const navigate = useNavigate();

  // Navigate to detail page instead of opening a modal
  const handleViewDetails = (datasetId) => {
    navigate(`/datasets/${datasetId}`, { state: { from: "/fine-tuning" } });
  };

  const handleDeleteDataset = async (datasetId) => {
    await deleteDataset(datasetId);
    const all = await queryAllDatasets();
    setDatasets(all);
  };

  // Show loading spinner while datasets prop is null or undefined
  if (!datasets) {
    return (
      <div className="flex justify-center py-8">
        <span className="w-6 h-6 border-2 border-dashed rounded-full animate-spin border-ktx-purple"></span>
      </div>
    );
  }

  // Empty state
  if (datasets.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        No datasets available. Upload a dataset to get started.
      </div>
    );
  }

  return (
    <div className="w-full">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {datasets.map(dataset => (
          <div
            key={dataset.id}
            className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow"
          >
            <div className="bg-ktx-purple text-white p-3">
              <h3 className="font-medium truncate">{dataset.name}</h3>
            </div>

            <div className="p-4">
              <p className="text-sm text-gray-600 mb-4 truncate">{dataset.location}</p>

              <div className="flex space-x-2">
                <button
                  onClick={() => handleViewDetails(dataset.name)}
                  className="flex-1 bg-ktx-purple text-white py-2 px-3 rounded text-sm hover:bg-ktx-navy focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ktx-purple transition-colors"
                >
                  View Details
                </button>

                <button
                  onClick={() => handleDeleteDataset(dataset.id)}
                  className="flex-1 bg-white text-ktx-red border border-current py-2 px-3 rounded text-sm hover:bg-red-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
